export interface BasketNotificationStore {
	visible: boolean;
	productType: string;
	showNotification(productType: string): void;
	forceHide(): void;
}

let closeTimer: ReturnType<typeof setTimeout> | null = null;
let reopenTimer: ReturnType<typeof setTimeout> | null = null;

const clearTimers = () => {
	if (closeTimer) {
		clearTimeout(closeTimer);
	}
	if (reopenTimer) {
		clearTimeout(reopenTimer);
	}
};

const startCloseTimer = (store: BasketNotificationStore) => {
	closeTimer = setTimeout(() => {
		store.visible = false;
	}, 30000);
};

export const basketNotificationStore: BasketNotificationStore = {
	visible: false,
	productType: "",

	showNotification(productType: string) {
		const wasVisible = this.visible;

		this.productType = productType;
		clearTimers();

		if (wasVisible) {
			this.visible = false;
			reopenTimer = setTimeout(() => {
				this.visible = true;
				startCloseTimer(this);
			}, 300);
		} else {
			this.visible = true;
			startCloseTimer(this);
		}
	},

	forceHide() {
		this.visible = false;
		clearTimers();
	},
};
